import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider, createTheme, Theme } from '@mui/material/styles';

import { configureAuth } from '@core/auth';
import PolicyModal from '@core/myta/components/PolicyModal';
import ProfileCompletionModal from '@core/myta/components/ProfileCompletionModal';
import LogoutNotificationModal from '@components/LogoutNotificationModal';
import LeftExperienceNotice from '@components/LeftExperienceNotice';
import NotificationProvider from '@providers/NotificationProvider/NotificationProvider';
import { MytaverseProvider } from '@providers/MytaverseProvider';
import { ModalCTARenderer } from '@providers/ModalCTAProvider';
import { NavigationHistoryTracker } from '@providers/NavigationHistoryProvider';
import Routes from './routes/Routes';
import i18next from './locales/i18n';
import { env } from 'env';

import './styles/App.scss';
import { getClientSpecificMultiRoleModal } from '@helpers/clientSpecificUtils';

const {
  // @ts-ignore
  REACT_APP_CLIENT_DEFAULT_FONTS,
} = env;

if (REACT_APP_CLIENT_DEFAULT_FONTS.includes('Noto Sans')) {
  require('./styles/fonts/noto.scss');
}
if (REACT_APP_CLIENT_DEFAULT_FONTS.includes('Poppins')) {
  require('./styles/fonts/poppins.scss');
}

const theme: Theme = createTheme({
  typography: {
    fontFamily: REACT_APP_CLIENT_DEFAULT_FONTS,
  },
});

require('./styles/Default.scss');

configureAuth();

declare module 'axios' {
  export interface AxiosRequestConfig {
    sendAuth0Headers?: boolean;
  }
}

const App = () => {
  return (
    <I18nextProvider i18n={i18next}>
      <ThemeProvider theme={theme}>
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <CssBaseline />
          <NavigationHistoryTracker />
          <NotificationProvider>
            <MytaverseProvider>
              <Routes />
              <PolicyModal />
              <ProfileCompletionModal />
              <LogoutNotificationModal />
              <LeftExperienceNotice />
              {getClientSpecificMultiRoleModal()}
              <ModalCTARenderer />
            </MytaverseProvider>
          </NotificationProvider>
        </BrowserRouter>
      </ThemeProvider>
    </I18nextProvider>
  );
};

export default App;
